/* src/pages/ContactPage.module.css */
.main { padding-top: var(--nav-height); }

.pageHero {
  padding: 5rem 0 4rem; text-align: center;
  background:
    radial-gradient(ellipse 60% 60% at 50% 40%, rgba(26,127,193,0.08) 0%, transparent 65%),
    var(--dark2);
  border-bottom: 1px solid var(--border);
}
.breadcrumb { display:flex; align-items:center; justify-content:center; gap:0.5rem; font-size:13px; color:var(--muted); margin-bottom:1.5rem; }
.breadcrumb a { color:var(--muted); transition:color var(--transition); }
.breadcrumb a:hover { color:var(--blue-light); }
.breadSep { color:var(--muted2); }
.pageH1 { font-size:clamp(36px,6vw,72px); margin:1.5rem auto 1rem; }
.pageSubtitle { font-size:18px; max-width:540px; margin:0 auto; }

.whyGrid { display:grid; grid-template-columns:repeat(3,1fr); gap:1.5rem; }
.whyCard {
  text-align:center; padding:2rem; background:var(--card);
  border:1px solid var(--border); border-radius:var(--radius);
  transition:border-color var(--transition), transform var(--transition);
}
.whyCard:hover { border-color:var(--border-strong); transform:translateY(-3px); }

.contactMain { padding:80px 0 100px; }
.contactLayout { display:grid; grid-template-columns:1fr 1.6fr; gap:4rem; align-items:start; }

.contactCards { display:flex; flex-direction:column; gap:1rem; }
.contactCard {
  background:var(--card); border:1px solid var(--border);
  border-radius:var(--radius); padding:1.3rem 1.5rem;
  display:flex; align-items:flex-start; gap:1rem;
  transition:border-color var(--transition), transform var(--transition);
}
.contactCard:hover { border-color:var(--border-strong); transform:translateX(4px); }
.contactCardIcon {
  width:44px; height:44px; border-radius:10px; flex-shrink:0;
  background:var(--blue-pale); border:1px solid rgba(63,168,232,0.2);
  display:flex; align-items:center; justify-content:center; font-size:20px;
}
.contactCardTitle { font-size:13px; font-weight:700; color:var(--blue-light); text-transform:uppercase; letter-spacing:0.5px; margin-bottom:0.25rem; }
.contactCardValue { font-size:15px; color:var(--text); text-decoration:none; }
.contactCardValue:hover { color:var(--blue-light); }
.contactCardSub { font-size:12px; color:var(--muted); margin-top:2px; }

.hoursBlock { margin-top:2.5rem; }
.hoursTitle { font-size:14px; font-weight:700; letter-spacing:0.5px; text-transform:uppercase; color:var(--muted); margin-bottom:0.5rem; }
.hoursRow { display:flex; justify-content:space-between; align-items:center; padding:10px 0; border-bottom:1px solid var(--border); font-size:14px; }
.hoursRow:last-child { border-bottom:none; }
.hoursDay { color:var(--muted); }
.hoursTime { color:var(--text); font-weight:500; display:flex; align-items:center; gap:8px; }
.openBadge {
  font-size:11px; font-weight:700; letter-spacing:1px;
  color:var(--green); background:var(--green-pale);
  border:1px solid rgba(61,187,47,0.2);
  padding:2px 8px; border-radius:4px;
}

.formWrap {
  background:var(--card); border:1px solid var(--border);
  border-radius:var(--radius-lg); padding:3rem;
  position:sticky; top:90px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.06);
}
.formTitle {
  font-family:'Bebas Neue',sans-serif; font-size:32px; letter-spacing:2px;
  color:var(--blue-light); margin-bottom:0.4rem;
}
.formRow { display:grid; grid-template-columns:1fr 1fr; gap:1rem; }
.formGroup {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.formGroup label {
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--muted);
}
.formGroup input,
.formGroup select,
.formGroup textarea {
  width: 100%;
  min-height: 48px;
  padding: 1rem 1rem;
  border-radius: 16px;
  border: 1px solid var(--border);
  background: var(--dark2);
  color: var(--text);
  font-size: 0.96rem;
  transition: border-color var(--transition), box-shadow var(--transition);
}
.formGroup select { appearance: none; background-image: linear-gradient(45deg, transparent 50%, currentColor 50%), linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position: calc(100% - 1rem) calc(1rem + 2px), calc(100% - 0.75rem) calc(1rem + 2px);
  background-size: 8px 8px, 8px 8px;
  background-repeat: no-repeat;
}
.formGroup textarea {
  min-height: 140px;
  resize: vertical;
}
.formGroup input:focus,
.formGroup select:focus,
.formGroup textarea:focus {
  outline: none;
  border-color: var(--blue-light);
  box-shadow: 0 0 0 4px rgba(63, 168, 232, 0.15);
}
.fieldError { display:block; font-size:12px; color:#e24b4a; margin-top:4px; }
.consentRow { display:flex; align-items:flex-start; gap:10px; margin-bottom:1.25rem; }
.consentRow input[type="checkbox"] { width:auto; flex-shrink:0; margin-top:3px; cursor:pointer; }
.consentLabel { font-size:12px; color:var(--muted); cursor:pointer; line-height:1.6; }
.submitBtn {
  width:100%; background:linear-gradient(135deg,var(--blue) 0%,var(--green-dark) 100%);
  border:none; border-radius:999px; padding:18px 24px;
  color:#fff; font-family:'Inter',sans-serif; font-size:15px; font-weight:700;
  letter-spacing:0.35px; text-transform:uppercase;
  cursor:pointer; transition:transform var(--transition), box-shadow var(--transition), opacity var(--transition);
  display:flex; align-items:center; justify-content:center; gap:8px;
  box-shadow: 0 18px 40px rgba(15,64,107,0.18);
}
.submitBtn:hover:not(:disabled) { opacity:0.98; transform:translateY(-1px); box-shadow: 0 22px 46px rgba(15,64,107,0.22); }
.submitBtn:disabled { opacity:0.6; cursor:not-allowed; }
.submitError { margin-top: 1rem; padding: 1rem 1.25rem; border-radius: 16px; background: rgba(226,75,74,0.1); color: #e24b4a; font-size: 13px; border: 1px solid rgba(226,75,74,0.18); }
.formNote { font-size:12px; color:var(--muted2); text-align:center; margin-top:1rem; }

.successState { text-align:center; padding:2rem 0; }
.successTitle {
  font-family:'Bebas Neue',sans-serif; font-size:32px; letter-spacing:2px;
  color:var(--green); margin-bottom:0.5rem;
}

.mapSection { padding:0 0 100px; }
.mapEmbed {
  width:100%; min-height:380px;
  background:var(--card2); border:1px solid var(--border);
  border-radius:var(--radius-lg); overflow:hidden;
  display:flex; flex-direction:column; align-items:center;
  justify-content:center; gap:1rem; color:var(--muted);
  font-size:14px; text-align:center; padding:3rem;
}

.directSection {
  padding:60px 0; background:var(--dark2);
  border-top:1px solid var(--border); border-bottom:1px solid var(--border);
}

@media (max-width:900px) {
  .contactLayout { grid-template-columns:1fr; }
  .formWrap { position:static; }
  .whyGrid { grid-template-columns:1fr; }
  .formRow { grid-template-columns:1fr; }
}
